import { render } from "./PageTitleUserName.vue?vue&type=template&id=6b46c19f"
import script from "./PageTitleUserName.vue?vue&type=script&lang=js"
export * from "./PageTitleUserName.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PageTitleUserName.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b46c19f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b46c19f', __exports__)) {
    api.reload('6b46c19f', __exports__)
  }
  
  module.hot.accept("./PageTitleUserName.vue?vue&type=template&id=6b46c19f", () => {
    api.rerender('6b46c19f', render)
  })

}


export default __exports__